<template>
	<div class="bg-box rounded shadow-md leases-box" :class="{ 'h-full': fullHeight }">
		<div class="relative">
			<div class="p-3 flex items-center justify-center text-xl text-white font-bold rounded-t site-title-bar">
				<div>Leases Due in</div>
				<div class="flex items-center ml-3">
					<div class="dropdown ml-1.5">
						<div class="flex items-center">
							<div class="border-b border-blue-200 border-dotted pb-px mr-1">
								<div class="mr-1 inline" v-text="timeFrameText"></div>{{ timeFrame == 12 ? 'Year' : 'Years' }}
							</div>
							<inline-svg name="chevron-down" classes="fill-current text-blue h-4 w-4 cursor-pointer"></inline-svg>
						</div>
						<div class="dropdown-menu" style="width: 130px;">
							<ul class="text-sm text-center">
								<li @click="timeFrame = 12"><a href="javascript:void(0);">1 Year</a></li>
								<li @click="timeFrame = 24"><a href="javascript:void(0);">2 Years</a></li>
								<li @click="timeFrame = 36"><a href="javascript:void(0);">3 Years</a></li>
								<li @click="timeFrame = 48"><a href="javascript:void(0);">4 Years</a></li>
								<li @click="timeFrame = 60"><a href="javascript:void(0);">5 Years</a></li>
							</ul>
						</div>
					</div>
					<div class="absolute right-3 top-1/2 -translate-y-1/2">
						<InfoIcon 
							ref="leasesDueInInfoIcon"
							identifier="dashboard-leasesduein" 
							@visibility-change="handleLeasesDueTooltip"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="mt-3 p-2 flex justify-between">
			<div class="mb-5 w-3/5 flex flex-col justify-between">
				<div class="flex flex-col text-center">
					<div class="text-lg text-white font-semibold">Square Footage</div>
					<span class="text-sm text-white" v-text="upcomingSquareFootageMessage"></span>
					<linear-gauge-chart :height="55" :value="upcomingSquareFootagePercentage"></linear-gauge-chart>
				</div>

				<div class="flex flex-col text-center">
					<div class="text-lg text-white font-semibold">Property Count</div>
					<span class="text-sm text-white" v-text="upcomingPropertyCountMessage"></span>
					<linear-gauge-chart :height="55" :value="upcomingPropertyCountPercentage"></linear-gauge-chart>
				</div>
			</div>

			<div class="w-2/5 flex-1 text-center">
				<div class="mb-3">
					<div class="text-lg text-white font-semibold">Utilization</div>
					<div class="text-sm text-white">Total Utilization <span v-text="utilization"></span>%</div>
				</div>
		         <div class="relative z-[0]">
					<fusioncharts
					  	v-if="!isTooltipVisible"
						type="cylinder"
						width="100%"
						height="220"
						:dataSource="utilizationChart"
						:key="'utilization-chart-' + utilization">
					</fusioncharts>
				</div>
			</div>
		</div>
    </div>
</template>


<script>
	import moment from 'moment';
	import { mapState } from 'vuex';

    export default {
        props: {
            siteData: {
              type: Array,
              required: true
            },

            fullHeight: {
            	type: Boolean,
            	default: false
            }
        },

        data () {
            return {
            	timeFrame: 36,
				isTooltipVisible:false,
            }
        },

        mounted() {
            this.sites.all = this.siteData
            this.sites.filtered = this.siteData.filter(site => {
                return site.archived_at == null;
            });
            this.$emit('filterRequest');

			this.$root.$on('tooltip-visibility', (visible) => {
				this.isTooltipVisible = visible;
			});
        },
		// beforeDestroy() {
    	// 	this.$root.$off('tooltip-visibility');
  		// },
		methods: {
			 handleLeasesDueTooltip(visible) {
				this.isTooltipVisible = visible;
				// Emit to parent to also hide the PieChart
				this.$emit('leases-due-tooltip', visible);
			}
		},
        computed: {
        	...mapState(['sites']),

        	timeFrameText() {
        		return this.timeFrame / 12;
        	},

        	utilization() {
        		if (this.upcomingSquareFootage == 0) {
        			return 0;
        		}

        		let usedSquareFootage = _.sumBy(this.upcomingSites, (site) => {
        			return site.size * (site.utilization/100);
        		});

        		return Math.round((usedSquareFootage / this.upcomingSquareFootage) * 100);
        	},

        	availableSites() {
            return this.sites.all.filter((site) => {
                return moment(site.lease_end_date).isAfter(moment());
        		});
        	},

        	totalPortfolioSquareFootage() {
                return _.sumBy(this.availableSites, 'size');
        	},

        	upcomingSites() {
				    return this.availableSites.filter((site) => {
        		    return moment(site.lease_end_date).isBefore(moment().add(this.timeFrame, 'M'))
        		});
        	},

        	upcomingSquareFootage() {
        		return this.availableSites.length == 0
        			? 0
        			: _.sumBy(this.upcomingSites, 'size');
        	},

        	upcomingSquareFootagePercentage() {
        		return this.availableSites.length == 0
        			? 0
        			: Math.round((this.upcomingSquareFootage / this.totalPortfolioSquareFootage) * 100);
        	},

        	upcomingSquareFootageMessage() {
        		return this.formatNumber(this.upcomingSquareFootage) + ' of ' + this.formatNumber(this.totalPortfolioSquareFootage) + ' Sq. Ft.';
        	},

        	upcomingPropertyCountPercentage() {
        		return this.availableSites.length == 0
        			? 0
        			: Math.round((this.upcomingSites.length / this.availableSites.length) * 100);
        	},

        	upcomingPropertyCountMessage() {
        		return this.upcomingSites.length + ' of ' + this.availableSites.length + ' Sites';
        	},

			utilizationColor() {
				if (this.utilization <= 70)
					return '#FB0000';
				else if (this.utilization >= 70 && this.utilization <= 79)
					return '#FF6A03';
				else if (this.utilization >= 80 && this.utilization <= 89)
					return '#FFFE58';
				else if (this.utilization > 90 && this.utilization <= 100)
					return '#01DE3B';
				else
					return '#FF50FF';
			},

			utilizationChart() {
				return {
					chart: {
						bgColor: "#316DA0",
            baseFont: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"',
            baseFontSize: 15,
						caption: "",
						lowerLimit: "0",
						upperLimit: "100",
						lowerLimitDisplay: "0%",
						upperLimitDisplay: "150%",
						numberSuffix: "%",
						cylFillColor: this.utilizationColor,
						plotToolText: "Utilization %",
						cylFillHoverAlpha: "85",
						ticksOnRight: "0",
						minorTMColor: "#ffffff",
						majorTMColor: "#ffffff",
						labelFontColor: "#ffffff",
						valueFontSize: 16,
						theme: "fusion",
					},
					value: this.utilization
				}
			},
    }
    }
</script>
